import { render, staticRenderFns } from "./EditSOSPopUp.vue?vue&type=template&id=15a2aefa&scoped=true"
import script from "./EditSOSPopUp.vue?vue&type=script&lang=js"
export * from "./EditSOSPopUp.vue?vue&type=script&lang=js"
import style0 from "./EditSOSPopUp.vue?vue&type=style&index=0&id=15a2aefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a2aefa",
  null
  
)

export default component.exports